import { Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startWithUpperCase } from "../../helpers";
import { IAuthState } from "../../stateManagement/reducers/authReducer";
import {
  ICustomer,
  ICustomersState,
  IEnumCustomer,
  tryFetchCustomers,
} from "../../stateManagement/reducers/customersReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import IconText from "../IconText";

interface ICustomersMenuProps {
  setCustomerId?: (id: string | null) => void;
  setCustomer?: (customer: IEnumCustomer | null) => void;
  reAssigning?: boolean;
  assigning?: boolean;
}

const CustomersMenu: React.FC<ICustomersMenuProps> = ({
  setCustomer,
  setCustomerId,
  reAssigning,
  assigning,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const dispatch = useDispatch<any>();

  const { authToken, user } = useSelector<IRootReducerT, IAuthState>(
    (state) => state.auth
  );
  const { fetchingCustomers, customers } = useSelector<
    IRootReducerT,
    ICustomersState
  >((state) => state.customers);
  useEffect(() => {
    dispatch(
      tryFetchCustomers({
        authToken: authToken ?? "",
      })
    );
  }, []);

  return (
    <div>
      <Button
        id="customers-menu-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        color="primary"
        size="medium"
        onClick={handleClick}
      >
        {reAssigning &&
          `${assigning ? "Assigning" : "Assign"} Another Customer`}
        {!reAssigning && `${assigning ? "Assigning" : "Assign"} Customer`}
      </Button>

      <Menu
        id="customers-positioned-menu"
        aria-labelledby="customers-menu-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{ zIndex: 1400000000000000000, position: "absolute" }}
        // anchorOrigin={{
        //   vertical: 'top',
        //   horizontal: 'left',
        // }}
        // transformOrigin={{
        //   vertical: 'top',
        //   horizontal: 'left',
        // }}
      >
        {customers.length > 0 && (
          <>
            <Typography p={0.5} variant="body1" color="secondary">
              Select Customer
            </Typography>
            {customers.map((customer: ICustomer, index: number) => {
              return (
                <>
                  <MenuItem
                    key={index}
                    onClick={(e) => {
                      if (setCustomerId) {
                        setCustomerId(customer._id);
                      }
                      if (setCustomer) {
                        setCustomer(customer as unknown as IEnumCustomer);
                      }
                      handleClose();
                    }}
                  >
                    <IconText
                      iconSrc={customer.imgSrc ?? null}
                      topText={`${startWithUpperCase(
                        customer.firstName
                      )} ${startWithUpperCase(customer.lastName)}`}
                      bottomText={""}
                    />
                    <Grid
                      container
                      spacing={0.5}
                      direction="column-reverse"
                      ml={5}
                      justifyContent={"flex-end"}
                      alignItems={"flex-end"}
                    >
                      <Grid color="secondary" item xs="auto">
                        <Typography
                          variant="body2"
                          color="textSecondary"
                        ></Typography>
                      </Grid>
                    </Grid>
                  </MenuItem>
                </>
              );
            })}
          </>
        )}
        {customers.length === 0 && fetchingCustomers && (
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item>
              <Typography
                variant="body2"
                color="secondary"
                p={1}
                sx={{ fontWeight: 400, textAlign: "center" }}
              >
                Loading...
              </Typography>
            </Grid>
          </Grid>
        )}
        {customers.length === 0 && !fetchingCustomers && (
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item>
              <Typography
                variant="body2"
                color="secondary"
                p={1}
                sx={{ fontWeight: 400, textAlign: "center" }}
              >
                No Customer Yet.
              </Typography>
            </Grid>
          </Grid>
        )}
      </Menu>
    </div>
  );
};

export default CustomersMenu;
